import React, { useState, useEffect } from 'react';
import {
    Table, TableBody, TableCell, TableContainer, TableRow, Paper,
    TableHead, TablePagination, TextField, Dialog,
    DialogActions, DialogContent, Box, DialogContentText, DialogTitle, Button, Typography, Link
} from '@mui/material';
import { useUser } from '../contexts/UserContext';
import Swal from 'sweetalert2';
import AddTarea from './AddTarea';
import { useAccesos } from '../contexts/AccesosContext';


function GestionTarea({idOportunidad = null}) {
    // Estado con tareas simuladas
        const server = process.env.REACT_APP_API_ROUTE;
        const key = process.env.REACT_APP_API_KEY;
        const [tareas, setTareas] = useState([]);
        const [editTarea, setEditTarea] = useState(null);
        const [searchQuery, setSearchQuery] = useState('');
        const [page, setPage] = useState(0);
        const [rowsPerPage, setRowsPerPage] = useState(5);
        const [openDialog, setOpenDialog] = useState(false);
        const [tareaToDelete, setTareaToDelete] = useState(null);
        const { user } = useUser();   
        const { tienePermiso } = useAccesos();

    // const navigate = useNavigate();

            const fetchTareas = async () => {
                    try {
                        const response = await fetch(`${server}/CrmTareas/poridOportunidad/${idOportunidad}`);
                        const data = await response.json();
                        setTareas(data.$values);
                    } catch (error) {
                        console.error('Error al cargar las Tareas:', error);
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Error al cargar las Tareas: ' + error,
                        });
                    }
                };

            useEffect(() => {
                const fetchTareas = async () => {
                    try {
                        let response;
                        if(idOportunidad) {
                            response = await fetch(`${server}/CrmTareas/poridOportunidad/${idOportunidad}`);
                        } else {
                            response = await fetch(`${server}/CrmTareas`);
                        }

                        const data = await response.json();
                        setTareas(data.$values || []);
                        
                    } catch (error) {
                        console.error('Error al cargar las tareas', error);
                        Swal.fire({
                            icon:'error',
                            title:'Error',
                            text: 'Error al cargar las tareas: '+ error,
                        });
                    }

                };

                
                    fetchTareas(idOportunidad);
                
            }, [idOportunidad]);
        
            
        if (!idOportunidad) {
            return (
                <Typography variant="body1" color="textSecondary">
                    Selecciona una oportunidad para ver sus tareas.
                </Typography>
            );
        }
            const handleNewTarea = () => {
                if(idOportunidad) {
                    fetch(`${server}/CrmTareas/poridOportunidad/${idOportunidad}`)
                    .then(res => res.json())
                    .then(data => setTareas(data.$values || []))
                    .catch(console.error);
                }else{
                    fetch(`${server}/CrmTareas`)
                    .then(res => res.json())
                    .then(data => setTareas(data.$values || []))
                    .catch(console.error);
                }
                
                setEditTarea(null);
            };
        
            const handleChangePage = (event, newPage) => {
                setPage(newPage);
            };
        
            const handleChangeRowsPerPage = (event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0);
            };
        
            const handleSearchChange = (event) => {
                setSearchQuery(event.target.value);
            };
        
            const handleOpenDialog = (tarea) => {
                setTareaToDelete(tarea);
                setOpenDialog(true);
            };
        
            const handleCloseDialog = () => {
                setOpenDialog(false);
                setTareaToDelete(null);
            };
        
            const handleDeleteTarea= async () => {
                if (tareaToDelete) {
                    try {
                        const username = ''+user.codigoUsuario+'/';
        
                        const response = await fetch(`${server}/CrmTareas/${tareaToDelete.id}/${username}`,
                             {
                            method: 'DELETE'
                        });
                        if (response.ok) {
                            handleCloseDialog();
                            fetchTareas(idOportunidad); // Recargar la lista de campanias
                            Swal.fire({
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Tarea eliminada con éxito',
                            });
                        } else {
                            handleCloseDialog();
        
                            const errorData = await response.json();
                            const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                            Swal.fire({
                                icon: 'error',
                                title: `Error ${response.status}`,
                                text: errorMessage,
                            });
                        }
                    } catch (error) {
                        console.error('Error al eliminar la tarea:', error);
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Error al eliminar la tarea: ' + error,
                        });            }
                }
            };
        
            const filteredTarea = tareas.filter(tarea => tarea.tituloTarea?.toLowerCase().includes(searchQuery.toLowerCase()));
    
        const handleCancelarEdicion = () => {
            setEditTarea(null);
        }

    return (
        <>
            <div className="x_content">
                <br />
                {/* <AddEstadoTarea /> */}
                {/* Botón para agregar nueva tarea */}
                <AddTarea handleNewTarea={handleNewTarea} editTarea={editTarea} idOportunidad={idOportunidad} cancelarEdicion={handleCancelarEdicion}/>
                <div className="ln_solid" />
                <h2>Tareas Existentes</h2>

                <TextField
                    fullWidth
                    variant="outlined"
                    label="Buscar Tarea"
                    placeholder="Buscar..."
                    value={searchQuery}
                    onChange={handleSearchChange}
                    style={{ marginBottom: '20px' }}
                />

                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell align="right"><strong>Acciones</strong></TableCell>
                                <TableCell><strong>Título</strong></TableCell>
                                <TableCell><strong>Descripción</strong></TableCell>
                                <TableCell><strong>Estado</strong></TableCell>
                                <TableCell><strong>Prioridad</strong></TableCell>
                                <TableCell><strong>Oportunidad</strong></TableCell>
                                {/* <TableCell><strong>Tarea Padre</strong></TableCell> */}
                                <TableCell><strong>Fecha Vencimiento</strong></TableCell>
                                <TableCell><strong>Usuario asignado</strong></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredTarea.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((tarea) => (
                                <TableRow key={tarea.id}>
                                    <TableCell align="right">
                                        <Button onClick={() => setEditTarea(tarea)} color="primary" disabled={!tienePermiso('Editar Tarea CRM')}>
                                            Editar
                                        </Button>
                                        <Button onClick={() => handleOpenDialog(tarea)} color="secondary" disabled={!tienePermiso('Eliminar Tarea CRM')}>
                                            Eliminar
                                        </Button>
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {tarea.tituloTarea}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {tarea.descripcionTarea}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                         <span style={{
                                            padding: '4px 8px',
                                            borderRadius: '5px',
                                            color: 'white',
                                            backgroundColor:
                                            tarea.estado?.toLowerCase() === 'por hacer' ? 'lightgray' :
                                            tarea.estado?.toLowerCase() === 'en progreso' ? 'green' :
                                            tarea.estado?.toLowerCase() === 'completada' ? 'gray' :
                                            tarea.estado?.toLowerCase() === 'cancelada' ? 'red' :
                                            tarea.estado?.toLowerCase() === 'vencida' ? 'brown' :
                                            ''
                                                        
                                            }}>
                                        {tarea.estado}
                                        </span>
                                    </TableCell>
                                    {/* <TableCell component="th" scope="row">
                                        {objetivo.IdCampania}
                                    </TableCell> */}
                                    <TableCell component="th" scope="row">
                                        {/* {tarea.prioridad} */}

                                         <span style={{
                                            padding: '4px 8px',
                                            borderRadius: '5px',
                                            color: 'white',
                                            backgroundColor:
                                            tarea.prioridad?.toLowerCase() === 'alta' ? '#FF6F00' :
                                            tarea.prioridad?.toLowerCase() === 'media' ? '#FFAB91' :
                                            tarea.prioridad?.toLowerCase() === 'baja' ? '#FFC4A3' :
                                            'gray'
                                        }}>
                                            {tarea.prioridad}
                                        </span>
                                    </TableCell>
                                     <TableCell component="th" scope="row">
                                        {tarea.nombreOportunidad}
                                    </TableCell>
                                    {/* <TableCell component="th" scope="row">
                                        {tarea.idTareaPadre}
                                    </TableCell> */}
                                    <TableCell component="th" scope="row">
                                        {tarea.fechaVencimiento}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {tarea.userAsignado}
                                    </TableCell>
                                </TableRow>
                            ))}                           
                        </TableBody>
                    </Table>

                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={tareas.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </TableContainer>

                    <Dialog open={openDialog}
                        onClose={handleCloseDialog}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description">
                        <DialogTitle id="alert-dialog-title">{"Confirmar eliminación"}</DialogTitle>
                        <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            ¿Estás seguro de que quieres eliminar esta tarea?
                        </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                        <Button onClick={handleCloseDialog} color="primary">Cancelar</Button>
                        <Button onClick={handleDeleteTarea} color="primary" autoFocus>Eliminar</Button>
                        </DialogActions>
                    </Dialog>
                 
            </div>
        </>
    );
}

export default GestionTarea;